// REASON ConnectIQ™ — shared brand constants (single source of truth for login/auth screens).
import {
  Users, Bot, MessagesSquare, BarChart3, Network, ShieldCheck,
} from "lucide-react";

export const PRODUCT_NAME = "ReasonConnectIQ\u2122";
export const PRODUCT_SUBTITLE = "Agentic AI Customer Intelligence & Engagement OS";
export const HERO_TITLE_LEAD = "The Agentic AI";
export const HERO_TITLE_REST = "Customer Intelligence & Engagement Operating System";
export const HERO_BLURB =
  "Unify customer data, conversations, service, marketing, workflows, knowledge and AI agents to deliver exceptional experiences and measurable business growth.";

export const APP_VERSION_LABEL = "Version 2.0 Enterprise Edition";

export const COMPANY_LINE = "\u00A9 2024 Reason Analytics Softech Pvt Ltd.";
export const RIGHTS_LINE = "All rights reserved.";
export const MADE_IN = "Built in India.";
export const MADE_FOR = "Ready for the World.";

// DPIIT recognition. Certificate values are editable — leave blank until provided by the business.
export const DPIIT = {
  title: "DPIIT Recognized Startup",
  ministry: "Ministry of Commerce & Industry, Government of India",
  certificateNo: "", // e.g. "DPIIT16968" — fill when provided
  validUntil: "", // e.g. "28/03/2030" — fill when provided
};

export const FEATURES = [
  { icon: Users, title: "Customer 360", desc: "Complete customer intelligence" },
  { icon: Bot, title: "Agentic AI Workforce", desc: "Autonomous agents that get work done" },
  { icon: MessagesSquare, title: "Omnichannel Engagement", desc: "Connect on every channel" },
  { icon: BarChart3, title: "Executive Intelligence", desc: "Real-time insights for faster decisions" },
  { icon: Network, title: "Digital Twin", desc: "Live customer digital representation" },
  { icon: ShieldCheck, title: "Enterprise Grade", desc: "Secure. Compliant. Scalable." },
];

export const TRUST_STRIP = [
  { icon: Users, title: "Multi-Tenant", desc: "Isolated. Scalable." },
  { icon: ShieldCheck, title: "Enterprise Security", desc: "RBAC. Audit. Encrypt." },
  { icon: Bot, title: "AI Powered", desc: "Intelligent. Predictive." },
];

export const LOGO_SRC = "/brand/reason-logo.jpg";
